import React, { useState } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { CreateRequeteDialog } from './CreateRequeteDialog';
import { SearchIcon, FilterIcon, MapPinIcon, MapIcon, TableIcon, FolderIcon, ChevronLeftIcon, ChevronRightIcon, ChevronsUpDownIcon, PlusIcon, SettingsIcon, XIcon, PaperclipIcon, CheckSquareIcon, SquareIcon, LinkIcon, TagIcon, FileTextIcon, PrinterIcon } from 'lucide-react';
type ViewMode = 'list' | 'map';
type Status = 'Nouvelle demande' | 'En Cours' | 'Complété' | 'En Attente' | 'Reçue';
interface Request {
  id: string;
  subject: string;
  category: string;
  reqId: string;
  location: string;
  date: string;
  status: Status;
  department: string;
  requester: {
    name: string;
    initials: string;
    color: string;
  };
  slaDate: string;
}
const MOCK_REQUESTS: Request[] = [{
  id: '1',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-101',
  location: '1520, 1 ère Rue, Richelieu,...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '2',
  subject: 'Bâtiment',
  category: 'Bâtiment',
  reqId: 'R-100',
  location: '205, Avenue 8e, Richelie...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juillet 2026'
}, {
  id: '3',
  subject: 'Nid-de-poule - trait...',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-99',
  location: '2907, Rang de la Savane, ...',
  date: '8 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Caroline Nadeau',
    initials: 'CN',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '4',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-98',
  location: '32, Place Rouville-Tessier,...',
  date: '8 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '13 juin 2026'
}, {
  id: '5',
  subject: 'Divers',
  category: 'Voirie et infrastructures routi...',
  reqId: 'R-97',
  location: '700, Rue Martel, Richelie...',
  date: '4 juin 2026',
  status: 'En Cours',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '9 juin 2026'
}, {
  id: '6',
  subject: 'Plateaux sportifs - t...',
  category: 'Parcs et espaces récréatifs',
  reqId: 'R-96',
  location: '900, Rue des Oblats, Ric...',
  date: '3 juin 2026',
  status: 'Complété',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Nathalie Ouellet',
    initials: 'NO',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '8 juin 2026'
}, {
  id: '7',
  subject: 'Refoulement égout...',
  category: 'Eau potable et égout',
  reqId: 'R-95',
  location: '192, Rue des Érables, Ric...',
  date: '3 juin 2026',
  status: 'Nouvelle demande',
  department: 'Service Des Travaux Publics',
  requester: {
    name: 'Éric Robin',
    initials: 'ÉR',
    color: 'bg-[#4F46E5]'
  },
  slaDate: '4 juin 2026'
}];
const getStatusColor = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-200 text-slate-700';
    case 'En Cours':
      return 'bg-indigo-100 text-indigo-700';
    case 'Complété':
      return 'bg-indigo-100 text-indigo-700';
    case 'En Attente':
      return 'bg-orange-100 text-orange-700';
    case 'Reçue':
      return 'bg-slate-100 text-slate-600';
    default:
      return 'bg-slate-100 text-slate-700';
  }
};
const getStatusDot = (status: Status) => {
  switch (status) {
    case 'Nouvelle demande':
      return 'bg-slate-400';
    case 'En Cours':
      return 'bg-[#4F46E5]';
    case 'Complété':
      return 'bg-[#4F46E5]';
    case 'En Attente':
      return 'bg-orange-500';
    case 'Reçue':
      return 'bg-slate-400';
    default:
      return 'bg-slate-400';
  }
};
// Request locations around Brossard, QC
const MAP_MARKERS: {
  reqId: string;
  subject: string;
  category: string;
  position: [number, number];
}[] = [{
  reqId: 'R-127',
  subject: 'Taxation',
  category: 'Administration',
  position: [45.4528, -73.4622]
}, {
  reqId: 'R-104',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4468, -73.4698]
}, {
  reqId: 'R-70',
  subject: 'Eau potable (qualité)',
  category: 'Eau potable et égout',
  position: [45.4552, -73.4578]
}, {
  reqId: 'R-103',
  subject: 'Feux de circulation',
  category: 'Éclairage public',
  position: [45.4438, -73.4728]
}, {
  reqId: 'R-57',
  subject: 'Lampadaire défectueux',
  category: 'Éclairage public',
  position: [45.4488, -73.4548]
}];
// Custom indigo map marker
const requestMarkerIcon = L.divIcon({
  className: '',
  html: `<div style="display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:9999px;background:#4F46E5;box-shadow:0 2px 6px rgba(0,0,0,0.3);border:2px solid white;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z"/></svg></div>`,
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  popupAnchor: [0, -14]
});
export function RequetesGerer() {
  const [viewMode, setViewMode] = useState<ViewMode>('list');
  const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  if (selectedRequest) {
    return <div className="bg-slate-50 -mx-4 sm:-mx-6 lg:-mx-8 -my-8 min-h-screen flex" data-id="element-5085" data-mp="2m4832upod7o1">
        {/* Left Pane - Citizen Visible */}
        <div className="w-1/2 border-r border-slate-200 bg-white flex flex-col" data-id="element-5086" data-mp="2r1zwxu9vr3uv">
          <div className="p-4 border-b border-slate-200 flex items-center gap-2 text-slate-500 text-sm font-medium" data-id="element-5087" data-mp="2v2jpslnf7lb7">
            <div className="w-4 h-4 rounded-full border-2 border-slate-300 flex items-center justify-center" data-id="element-5088" data-mp="303qxkkpkckhv">
              <div className="w-1.5 h-1.5 bg-slate-300 rounded-full" data-id="element-5089" data-mp="34zy52hxly41x"></div>
            </div>
            Visible par le citoyen
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6" data-id="element-5090" data-mp="1an827ap9hkie">
            <button className="pb-3 border-b-2 border-[#4F46E5] text-[#4F46E5] font-semibold text-sm" data-id="element-5091" data-mp="134idh5xsiob2">
              Infos
            </button>
            <button className="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-semibold text-sm" data-id="element-5092" data-mp="yd0aydg4cfnz">
              Messages
            </button>
          </div>

          <div className="p-6 overflow-y-auto flex-1" data-id="element-5093" data-mp="ognhngohk3tr">
            <div className="flex justify-between items-start mb-8" data-id="element-5094" data-mp="odrm1z041r8h">
              <div className="flex gap-4" data-id="element-5095" data-mp="1m2uo6w4co68r">
                <div className="w-12 h-12 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-5096" data-mp="1h4jbmdmo7hmu">
                  <FolderIcon className="w-6 h-6 text-[#4F46E5]" data-id="element-5097" data-mp="1c3vlrva6h6u7" />
                </div>
                <div data-id="element-5098" data-mp="17527w1qzbdti">
                  <div className="flex items-center gap-2" data-id="element-5099" data-mp="175k9zf0bom9c">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-5100" data-mp="qjh5i6lgk6z">
                      Entretien des parcs
                    </h2>
                    <ChevronLeftIcon className="w-4 h-4 text-slate-400 rotate-[-90deg]" data-id="element-5101" data-mp="3rurn4fvlh1mq" />
                  </div>
                  <div className="text-sm text-slate-500 mt-1 flex items-center gap-2" data-id="element-5102" data-mp="lh5gha8h5dq6">
                    <span className="bg-slate-100 px-2 py-0.5 rounded text-xs font-medium border border-slate-200" data-id="element-5103" data-mp="qfgqbkyrro8e">
                      R-71
                    </span>
                    <span data-id="element-5104" data-mp="gh0xndk3g6ws">Parcs et espaces récréatifs</span>
                  </div>
                  <div className="text-sm text-slate-400 mt-1 ml-10 border-l-2 border-slate-200 pl-2" data-id="element-5105" data-mp="145232dlz777z">
                    Service Des Travaux Publics
                  </div>
                </div>
              </div>
              <div className={`px-3 py-1 rounded-full text-sm font-medium flex items-center gap-2 ${getStatusColor('En Cours')}`} data-id="element-5106" data-mp="vc75m62r2fsr">
                <div className={`w-2 h-2 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5107" data-mp="1n4g1p8unh64t"></div>
                En Cours
              </div>
            </div>

            <div className="mb-8" data-id="element-5108" data-mp="1rwze42hlpv81">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5109" data-mp="3cks0fced4dd8">
                DESCRIPTION
              </h3>
              <div className="p-4 rounded-xl border border-slate-200 bg-white text-slate-700 text-sm leading-relaxed" data-id="element-5110" data-mp="37m6ztbv77ro9">
                Le parc près de la rue Principale nécessite un entretien urgent.
                Les poubelles débordent et il y a des branches cassées sur le
                sentier principal suite à la tempête d'hier soir. Cela
                représente un danger pour les piétons et les cyclistes.
              </div>
            </div>

            <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-5111" data-mp="33l595jfcknxw">
              <div data-id="element-5112" data-mp="33iirgqyqss1y">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5113" data-mp="2ym21rsbwa5mr">
                  DEMANDEUR
                </h3>
                <div className="flex items-start gap-3" data-id="element-5114" data-mp="it34k72n9nhl">
                  <div className="w-8 h-8 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-5115" data-mp="dvtfisj63dua">
                    NO
                  </div>
                  <div data-id="element-5116" data-mp="2v5w0qpc93c6o">
                    <div className="font-semibold text-slate-900 text-sm" data-id="element-5117" data-mp="2v7gwgiaax164">
                      Nathalie Ouellet
                    </div>
                    <div className="text-sm text-slate-500 mt-0.5" data-id="element-5118" data-mp="2qdmdxi6fms8m">
                      (450) 658-1157
                    </div>
                    <div className="text-sm text-slate-500" data-id="element-5119" data-mp="2gh9k8kaw0edv">
                      adjointe.tp@ville.richelieu.qc.ca
                    </div>
                  </div>
                </div>
              </div>
              <div data-id="element-5120" data-mp="27gbhe5c6qcwv">
                <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5121" data-mp="27hweo2pvw9yf">
                  EMPLACEMENT
                </h3>
                <div className="flex items-start gap-2" data-id="element-5122" data-mp="22k37p7grbbx3">
                  <MapPinIcon className="w-4 h-4 text-slate-400 mt-0.5 flex-shrink-0" data-id="element-5123" data-mp="5o5h1bgpl1xz" />
                  <div data-id="element-5124" data-mp="rf1qqcqaadm">
                    <div className="text-sm text-slate-700" data-id="element-5125" data-mp="r6mirt4usz9">
                      200 Boulevard Richelieu
                    </div>
                    <div className="text-sm text-slate-700" data-id="element-5126" data-mp="d8zi8mk5a5h7">
                      Richelieu, J3L 3R1
                    </div>
                    <button className="text-sm text-[#4F46E5] mt-1 hover:underline" data-id="element-5127" data-mp="hzfvo6nytr3k">
                      Voir sur la carte ▾
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-5128" data-mp="3li96wct9u3uk">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-5129" data-mp="3lispzwunqya6">
                PIÈCES JOINTES
              </h3>
              <div className="flex gap-3" data-id="element-5130" data-mp="3veci0863pctn">
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5131" data-mp="3vgozylbuzn6p">
                  <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5132" data-mp="49vyrhh2fo26" />
                </div>
                <div className="w-20 h-20 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5133" data-mp="3bptf805l0eok">
                  <img src="https://images.unsplash.com/photo-1519331379826-f10be5486c6f?w=200&h=200&fit=crop" alt="Parc" className="w-full h-full object-cover" data-id="element-5134" data-mp="36rrulasic7az" />
                </div>
                <button className="w-20 h-20 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5135" data-mp="3gqh70o1mwzju">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5136" data-mp="2nz79wgmyp8i9" />
                  <span className="text-xs font-medium" data-id="element-5137" data-mp="31t87v863arhk">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Pane - Internal */}
        <div className="w-1/2 bg-slate-50 flex flex-col relative" data-id="element-5138" data-mp="29at5i19wdbzl">
          <button onClick={() => setSelectedRequest(null)} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-200 transition-colors z-10" data-id="element-5139" data-mp="25b2a1k9fe7oq">
            <XIcon className="w-5 h-5" data-id="element-5140" data-mp="1zydj6wzgeo8y" />
          </button>

          <div className="p-4 border-b border-slate-200 flex items-center justify-between text-slate-500 text-sm font-medium bg-white" data-id="element-5141" data-mp="1l8o6q5lwuxtd">
            <div className="flex items-center gap-2" data-id="element-5142" data-mp="1q8k8dy74yd5r">
              <div className="w-4 h-4 rounded flex items-center justify-center border-2 border-slate-300" data-id="element-5143" data-mp="2dx3i8i5u2xzy">
                <div className="w-2 h-2 bg-slate-300 rounded-sm" data-id="element-5144" data-mp="2ivwnjnayvip1"></div>
              </div>
              Interne — non visible par le citoyen
            </div>
            <PrinterIcon className="w-4 h-4 mr-10" data-id="element-5145" data-mp="23ynsaiijlus1" />
          </div>

          <div className="px-6 pt-4 border-b border-slate-200 flex gap-6 bg-white" data-id="element-5146" data-mp="28wz24t8u85a9">
            <button className="pb-3 border-b-2 border-[#4F46E5] text-[#4F46E5] font-semibold text-sm" data-id="element-5147" data-mp="sj8sl6yy8ot8">
              Gestion
            </button>
            <button className="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-semibold text-sm" data-id="element-5148" data-mp="xk50dvmf8v3x">
              Collaboration
            </button>
            <button className="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-semibold text-sm" data-id="element-5149" data-mp="18yhpe333xuvk">
              Historique
            </button>
          </div>

          <div className="p-6 overflow-y-auto flex-1 space-y-6" data-id="element-5150" data-mp="z24xnar4hr3g">
            <div className="text-sm text-slate-500 font-medium" data-id="element-5151" data-mp="1wou3xwsuypv4">
              19 mai <span className="mx-2 text-slate-300" data-id="element-5152" data-mp="1wmrilq2nhkwq">→</span>{' '}
              <span className="text-red-500" data-id="element-5153" data-mp="1rqspjp6dnepz">26 mai</span>
            </div>

            {/* Tasks */}
            <div className="space-y-3" data-id="element-5154" data-mp="1mpd2jrkn2y4y">
              <div className="flex items-start gap-3" data-id="element-5155" data-mp="1mshdr8wiuu54">
                <CheckSquareIcon className="w-5 h-5 text-slate-900 mt-0.5" data-id="element-5156" data-mp="1hqjr04owxh7f" />
                <div className="flex-1" data-id="element-5157" data-mp="bc0wda1eq3fm">
                  <div className="text-sm text-slate-500 line-through" data-id="element-5158" data-mp="bcsr6in6jx4u">
                    Vérifier la disponibilité des équipes
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5" data-id="element-5159" data-mp="2i09vfho2v5m9">
                    Terminée: 22 mai 2026{' '}
                    <PencilIcon className="w-3 h-3 inline ml-1" data-id="element-5160" data-mp="2mzw9tufn6rwn" />
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5161" data-mp="2rx5uyxw00heo">
                  <CalendarIcon className="w-3 h-3" data-id="element-5162" data-mp="2woxnhdypsx7g" /> 22 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-indigo-500 text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5163" data-mp="31oa9xxloc29i">
                  ML
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5164" data-mp="3aop0bbdhw7jv">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5165" data-mp="3ap8ech00ybsm" />
                <div className="flex-1" data-id="element-5166" data-mp="3fmgxajszyjux">
                  <div className="text-sm text-slate-700" data-id="element-5167" data-mp="3fl5xev2o9w93">
                    Planifier le ramassage des branches
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5168" data-mp="1laabys6e2mow">
                  <CalendarIcon className="w-3 h-3" data-id="element-5169" data-mp="1d81e8zrstxux" /> 25 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full bg-[#4F46E5] text-white flex items-center justify-center text-[10px] font-bold" data-id="element-5170" data-mp="197purqb6a3l1">
                  ST
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-5171" data-mp="1i85yn0vtvcqf">
                <SquareIcon className="w-5 h-5 text-slate-300 mt-0.5" data-id="element-5172" data-mp="1i6l1r4m1jhpe" />
                <div className="flex-1" data-id="element-5173" data-mp="1w6m46ohyex6z">
                  <div className="text-sm text-slate-700" data-id="element-5174" data-mp="1w5ay2i11ddcp">
                    Contacter le demandeur pour suivi
                  </div>
                </div>
                <div className="text-xs text-red-500 flex items-center gap-1" data-id="element-5175" data-mp="25w5kpni72eyo">
                  <CalendarIcon className="w-3 h-3" data-id="element-5176" data-mp="20y4213ookhnq" /> 20 mai 2026
                </div>
                <div className="w-6 h-6 rounded-full border border-dashed border-slate-300 text-slate-400 flex items-center justify-center text-[10px]" data-id="element-5177" data-mp="2fvekwy3nkpth">
                  <UserIcon className="w-3 h-3" data-id="element-5178" data-mp="2ayefmpemnr3f" />
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-2" data-id="element-5179" data-mp="2uiv4bdi53cab">
                <PlusIcon className="w-4 h-4" data-id="element-5180" data-mp="2yhugnj67abbs" /> Ajouter une tâche
              </button>
            </div>

            {/* Linked Requests */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5181" data-mp="2pih7yspwhqs4">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5182" data-mp="2aumeha42jidz">
                REQUÊTES LIÉES
              </h3>
              <div className="space-y-3" data-id="element-5183" data-mp="2flw101ubm5ln">
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5184" data-mp="2fmxba43iio2b">
                  <div className="flex items-center gap-3" data-id="element-5185" data-mp="26tao32ddet4q">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5186" data-mp="1rv8fgdrhfhgm">
                      Liée ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5187" data-mp="2ccclr1nq677t">
                      R-68 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5188" data-mp="23bxz9yz0ym2q">
                      Lampadaire défectueux
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Attente')}`} data-id="element-5189" data-mp="1ycblnofab3te">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Attente')}`} data-id="element-5190" data-mp="1olz321r15kpw"></div>
                    En Attente
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5191" data-mp="1fnww75km7xup">
                  <div className="flex items-center gap-3" data-id="element-5192" data-mp="15nw876bswtk6">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5193" data-mp="15qifr5yoz92e">
                      Bloque ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5194" data-mp="10leyfulg4nh0">
                      R-72 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5195" data-mp="1agzw5gjhf1ky">
                      Nid-de-poule rue Principale
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('Reçue')}`} data-id="element-5196" data-mp="hs1ai9g5hhaw">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('Reçue')}`} data-id="element-5197" data-mp="rink9n16rdlo"></div>
                    Reçue
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 hover:bg-slate-50 rounded-lg border border-transparent hover:border-slate-100 transition-colors" data-id="element-5198" data-mp="3v7h5f121qf2c">
                  <div className="flex items-center gap-3" data-id="element-5199" data-mp="1rcs1vhi2bykm">
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5200" data-mp="1w8pg9i9rmuur">
                      Doublon ▾
                    </span>
                    <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded border border-slate-200" data-id="element-5201" data-mp="25aqgmo0apx0n">
                      R-75 ↗
                    </span>
                    <span className="text-sm text-slate-700" data-id="element-5202" data-mp="1dirbbb19lhvc">
                      Banc de parc endommagé
                    </span>
                  </div>
                  <div className={`px-2 py-0.5 rounded-full text-xs font-medium flex items-center gap-1.5 ${getStatusColor('En Cours')}`} data-id="element-5203" data-mp="1hirq4ws9zv2x">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot('En Cours')}`} data-id="element-5204" data-mp="pt6sqt90wmml"></div>
                    En Cours
                  </div>
                </div>
              </div>
              <button className="text-sm text-slate-500 font-medium flex items-center gap-1 hover:text-slate-700 mt-3" data-id="element-5205" data-mp="m9eo1r84dh1n">
                <PlusIcon className="w-4 h-4" data-id="element-5206" data-mp="daud5c8swbnz" /> Lier une requête
              </button>
            </div>

            {/* Tags */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5207" data-mp="8ayabgbuaqa0">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5208" data-mp="3dg4vzx16t6r">
                ÉTIQUETTES
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-5209" data-mp="3uq11kfbly3nn">
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5210" data-mp="3prznk8t1guj1">
                  Urgent <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5211" data-mp="3lot9wg3lk12j" />
                </span>
                <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-medium border border-indigo-100 flex items-center gap-1" data-id="element-5212" data-mp="3gr1e3aztzut2">
                  Suivi requis <XIcon className="w-3 h-3 cursor-pointer" data-id="element-5213" data-mp="3242pdnsczei1" />
                </span>
                <button className="px-3 py-1 rounded-full border border-dashed border-slate-300 text-slate-500 text-xs font-medium flex items-center gap-1 hover:border-slate-400 hover:text-slate-700 transition-colors" data-id="element-5214" data-mp="374h0jep9b4ka">
                  <PlusIcon className="w-3 h-3" data-id="element-5215" data-mp="2x6ssxo6jy2kp" /> Ajouter une étiquette
                </button>
              </div>
            </div>

            {/* Internal Files */}
            <div className="bg-white rounded-xl border border-slate-200 p-5" data-id="element-5216" data-mp="3pv85m427o8sv">
              <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4" data-id="element-5217" data-mp="3b5sh6uq5kfgc">
                FICHIERS INTERNES
              </h3>
              <div className="flex gap-3" data-id="element-5218" data-mp="3g3u2lmb1wquz">
                <div className="w-20 rounded-lg border border-slate-200 p-2 flex flex-col items-center justify-center text-center" data-id="element-5219" data-mp="3g2ivpdmb72zn">
                  <FileTextIcon className="w-8 h-8 text-red-500 mb-2" data-id="element-5220" data-mp="cgbwj4936jkq" />
                  <div className="text-[10px] font-medium text-slate-700 truncate w-full" data-id="element-5221" data-mp="1x67i7osw477b">
                    rapport_inspe...
                  </div>
                  <div className="text-[9px] text-slate-400" data-id="element-5222" data-mp="1s6bc9k0mu5p4">22 mai</div>
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5223" data-mp="26uz87ree4hfl">
                  <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5224" data-mp="21wnwtc8g5yv9" />
                </div>
                <div className="w-20 h-24 rounded-lg bg-slate-200 overflow-hidden" data-id="element-5225" data-mp="19alanxwm3bbr">
                  <img src="https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=200&h=200&fit=crop" alt="Doc" className="w-full h-full object-cover" data-id="element-5226" data-mp="1n5x2nxjdunoz" />
                </div>
                <button className="w-20 h-24 rounded-lg border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 hover:text-[#4F46E5] hover:border-[#4F46E5] transition-colors" data-id="element-5227" data-mp="2ukjqs96mtcoc">
                  <PlusIcon className="w-5 h-5 mb-1" data-id="element-5228" data-mp="3txvameklx6ec" />
                  <span className="text-xs font-medium" data-id="element-5229" data-mp="2rbtyis3am84">Téléverser</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-5230" data-mp="cphrko6v5676">
      {/* Header */}
      <div className="p-4 border-b border-slate-200" data-id="element-5231" data-mp="gqbdjc0qwaxf">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-5232" data-mp="goqlpu5tf639">
          <div className="flex items-center gap-3" data-id="element-5233" data-mp="libjpm7es02g">
            <div className="inline-flex items-center bg-slate-100 rounded-lg p-1 gap-1" data-id="element-5234" data-mp="qgwbqycibdft">
              <button onClick={() => setViewMode('list')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'list' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5235" data-mp="vg98qbx3e0w4">
                <TableIcon className="w-4 h-4" data-id="element-5236" data-mp="2fxif9vlxawdz" />
                Tableau
              </button>
              <button onClick={() => setViewMode('map')} className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-semibold transition-colors ${viewMode === 'map' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-5237" data-mp="2ay5l0psq2n1d">
                <MapIcon className="w-4 h-4" data-id="element-5238" data-mp="2ynzucxdu1tgv" />
                Carte
              </button>
            </div>
            <span className="text-sm text-slate-500" data-id="element-5239" data-mp="2twhte9bt7svw">10 demandes</span>
          </div>

          <div className="flex items-center gap-3" data-id="element-5240" data-mp="2oz8732jpvxca">
            <div className="relative" data-id="element-5241" data-mp="2owdlv8svq8ht">
              <SearchIcon className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-5242" data-mp="3medl8kkolm9v" />
              <input type="text" placeholder="Rechercher des requêtes..." className="pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm w-64 focus:outline-none focus:ring-2 focus:ring-[#4F46E5] focus:border-transparent" data-id="element-5243" data-mp="3hmvlu0yb3tr0" />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm font-semibold rounded-lg hover:bg-slate-50 transition-colors" data-id="element-5244" data-mp="15yqtao0keij2">
              <FilterIcon className="w-4 h-4" data-id="element-5245" data-mp="wykft24v9ijw" />
              Filtrer
            </button>
            <button onClick={() => setShowCreate(true)} className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors whitespace-nowrap" data-id="element-5246" data-mp="110ffy3b29pw3">
              <PlusIcon className="w-4 h-4" data-id="element-5247" data-mp="s098oz5yhm5d" />
              Créer une requête
            </button>
          </div>
        </div>
      </div>

      {/* Map View */}
      {viewMode === 'map' && <div className="h-[400px] w-full border-b border-slate-200" data-id="element-5248" data-mp="2md8u58x0pakk">
          <MapContainer center={[45.4499, -73.4653]} zoom={13} scrollWheelZoom={false} style={{
        height: '100%',
        width: '100%'
      }} data-id="element-5249" data-mp="arq7lr6iq6sq">
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-5250" data-mp="khszfo1wleph" />
            {MAP_MARKERS.map(m => <Marker key={m.reqId} position={m.position} icon={requestMarkerIcon} data-id="element-5251" data-mp="oil8oharzjlr">
                <Popup data-id="element-5252" data-mp="13ekn09ohafzc">
                  <div className="text-sm" data-id="element-5253" data-mp="yg9eq3du0dj8">
                    <div className="font-semibold text-slate-900" data-id="element-5254" data-mp="yhao83f78ryu">
                      {m.reqId} — {m.subject}
                    </div>
                    <div className="text-slate-500" data-id="element-5255" data-mp="358thnzs5468r">{m.category}</div>
                  </div>
                </Popup>
              </Marker>)}
          </MapContainer>
        </div>}

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-5256" data-mp="2jdjoou0qyr2p">
        <table className="w-full text-left border-collapse" data-id="element-5257" data-mp="2jci49yxucs8b">
          <thead data-id="element-5258" data-mp="2o4i7c097k194">
            <tr className="border-b border-slate-200 bg-white" data-id="element-5259" data-mp="2o4024e4kicp2">
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5260" data-mp="2o6mb8i73x09e">
                <span className="inline-flex items-center gap-1" data-id="element-5261" data-mp="2t55vme61y3zn">
                  Sujet{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5262" data-mp="1vhxgd0wn9r63" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5263" data-mp="25e0ii6rhxpt1">
                <span className="inline-flex items-center gap-1" data-id="element-5264" data-mp="29f3x6pxt5fso">
                  Catégorie{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5265" data-mp="3gt7by99h2opm" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5266" data-mp="3ktr93cu1psbr">
                <span className="inline-flex items-center gap-1" data-id="element-5267" data-mp="197p4medwc05w">
                  ID Requête{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5268" data-mp="155bwjjbofq5y" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5269" data-mp="10dkgw3u274ul">
                Emplacement
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5270" data-mp="vdy1bnqrdcim">
                <span className="inline-flex items-center gap-1" data-id="element-5271" data-mp="qebeqnp1ijx5">
                  Date de création{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5272" data-mp="hfzq2r7qhw7c" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5273" data-mp="chg3colbggdx">
                <span className="inline-flex items-center gap-1" data-id="element-5274" data-mp="2btr03rtz6i3b">
                  Statut{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5275" data-mp="26v7b1ik34q6q" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5276" data-mp="2x41qfxf0nl5l">
                <span className="inline-flex items-center gap-1" data-id="element-5277" data-mp="2s6jpoub5kc8o">
                  Département{' '}
                  <ChevronsUpDownIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5278" data-mp="35xev1wmg0b7i" />
                </span>
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5279" data-mp="31wuyov9p1bmf">
                Demandeur
              </th>
              <th className="px-4 py-3 text-xs font-semibold text-slate-500 whitespace-nowrap" data-id="element-5280" data-mp="296w1gclci86o">
                Date SLA
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-5281" data-mp="2n7yrt1jdi4ne">
            {MOCK_REQUESTS.map(req => <tr key={req.id} onClick={() => setSelectedRequest(req)} className="hover:bg-slate-50 cursor-pointer transition-colors" data-id="element-5282" data-mp="2i69dnd0utav3">
                <td className="px-4 py-3 text-sm text-slate-700 whitespace-nowrap" data-id="element-5283" data-mp="3tmhlntz21ee5">
                  <div className="flex items-center gap-2" data-id="element-5284" data-mp="5wsqgswip2yu">
                    <div className="w-8 h-8 rounded bg-slate-50 border border-slate-200 flex items-center justify-center" data-id="element-5285" data-mp="a0gzlg0ss6m7">
                      <FolderIcon className="w-4 h-4 text-[#4F46E5]" data-id="element-5286" data-mp="3s6lsm5svozlr" />
                    </div>
                    {req.subject}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5287" data-mp="oobsoxipwczt">
                  {req.category}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5288" data-mp="tneywlafop9d">
                  {req.reqId}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5289" data-mp="ex7mam73y0gl">
                  <div className="flex items-center gap-1" data-id="element-5290" data-mp="jw24blx93kzn">
                    {req.location}
                    <MapPinIcon className="w-3 h-3 text-[#4F46E5]" data-id="element-5291" data-mp="17lmqedopayd5" />
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5292" data-mp="1cg94wpq2x71g">
                  {req.date}
                </td>
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-5293" data-mp="1hatln2fvrkhv">
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${getStatusColor(req.status)}`} data-id="element-5294" data-mp="1h9ilrdpk2ww1">
                    <div className={`w-1.5 h-1.5 rounded-full ${getStatusDot(req.status)}`} data-id="element-5295" data-mp="18adjpxesclf4"></div>
                    {req.status}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5296" data-mp="yj0ttbcjs5bq">
                  {req.department}
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5297" data-mp="onfq98rtywzv">
                  <div className="flex items-center gap-2" data-id="element-5298" data-mp="klkltvels3hv">
                    <div className={`w-6 h-6 rounded-full ${req.requester.color} text-white flex items-center justify-center text-[10px] font-bold`} data-id="element-5299" data-mp="kn5fzjx09kf7">
                      {req.requester.initials}
                    </div>
                    {req.requester.name}
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap" data-id="element-5300" data-mp="309rlvy4rh2d0">
                  {req.slaDate}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="p-4 border-t border-slate-200 flex items-center justify-end gap-6 text-sm text-slate-500" data-id="element-5301" data-mp="28kog2dx87jy9">
        <div className="flex items-center gap-2" data-id="element-5302" data-mp="2ci2nq159djo5">
          Éléments par page
          <select className="border-b border-slate-300 pb-1 focus:outline-none bg-transparent font-medium text-slate-700" data-id="element-5303" data-mp="2hi75duhwkkfy">
            <option data-id="element-5304" data-mp="2mc32kuqce3a2">10</option>
            <option data-id="element-5305" data-mp="1ovdyeudx6oxi">20</option>
            <option data-id="element-5306" data-mp="1oubbsynmr8ne">50</option>
          </select>
        </div>
        <div data-id="element-5307" data-mp="1ttfinin30uak">1 - 10 / 98</div>
        <div className="flex items-center gap-4" data-id="element-5308" data-mp="1tsmk34ya1b3i">
          <button className="hover:text-slate-900" data-id="element-5309" data-mp="b899jzjtxbp">
            <ChevronLeftIcon className="w-4 h-4" data-id="element-5310" data-mp="bqc4zgpv9sl" />
          </button>
          <button className="hover:text-slate-900" data-id="element-5311" data-mp="3riay44rwzrir">
            <ChevronRightIcon className="w-4 h-4" data-id="element-5312" data-mp="3rff1cjrsz8vw" />
          </button>
        </div>
      </div>

      {showCreate && <CreateRequeteDialog onClose={() => setShowCreate(false)} data-id="element-5313" data-mp="4cttjqeexdvx" />}
    </div>;
}
// Missing icons for the component
function CalendarIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5314" data-mp="e2lncieou2zc">
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" data-id="element-5315" data-mp="o1av3icve71v" />
      <line x1="16" x2="16" y1="2" y2="6" data-id="element-5316" data-mp="2tt7ypff27qm6" />
      <line x1="8" x2="8" y1="2" y2="6" data-id="element-5317" data-mp="2tu152fa3we3s" />
      <line x1="3" x2="21" y1="10" y2="10" data-id="element-5318" data-mp="2psfmcdaw55lo" />
    </svg>;
}
function UserIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5319" data-mp="2fpabto6i94b3">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" data-id="element-5320" data-mp="2axir3ua15ssv" />
      <circle cx="12" cy="7" r="4" data-id="element-5321" data-mp="2avxvs2fw65ty" />
    </svg>;
}
function PencilIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-5322" data-mp="1w2l1382ctfey">
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" data-id="element-5323" data-mp="1rzg0jb1u3nsy" />
      <path d="m15 5 4 4" data-id="element-5324" data-mp="3hd1m14d3r3b2" />
    </svg>;
}